import { FormControlLabel, Radio, RadioGroup } from "@mui/material"
import * as React from "react"
import { useGridApiContext } from "@mui/x-data-grid"

const RadioGroupEditInputCell = ({ id, value, field, options }) => {
  const apiRef = useGridApiContext()

  const handleChange = event => {
    apiRef.current.setEditCellValue({ id, field, value: event.target.value })
    apiRef.current.stopCellEditMode({ id, field })
  }

  return (
    <RadioGroup row name="controlled-radio-buttons-group" value={value} onChange={handleChange}>
      {(
        options || [
          { value: "", label: "None" },
          { value: "Y", label: "Yes" },
          { value: "N", label: "No" },
        ]
      ).map(x => (
        <FormControlLabel key={x.value} value={x.value} control={<Radio />} label={x.label} />
      ))}
    </RadioGroup>
  )
}

export default RadioGroupEditInputCell
